import Agent from "./agent/Agent";
import Chatbot from "./bot/Chatbot";

const Chat = ({ isAgent }) => {
  return <div>{isAgent ? <Agent /> : <Chatbot />}</div>;
};

export default Chat;
